import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    marginBottom: 18,
  },
  usageItemContainerStyle: theme => ({
    borderBottomColor: theme.colors.borderColorThree,
    borderBottomWidth: 1,
    paddingVertical: 17,
  }),
});
